export function EmptyState({
  title = "Nothing matches",
  hint = "Loosen a filter, or wait for the next county pull.",
}: {
  title?: string;
  hint?: string;
}) {
  return (
    <div className="empty">
      <b>{title}</b>
      {hint}
    </div>
  );
}
